//import React from 'react'

import Badge from 'react-bootstrap/Badge'
import Button from 'react-bootstrap/Button'
import {useParams} from 'react-router-dom'

import React, { useState } from 'react';



function CarPage() {
    let { id } = useParams();
    let svparams = { 'id': id}
    return (
        <div style={{ fontSize: "50px" }}>
            Now CarPage post {id}
           
        </div>
    );
}
export default CarPage

/*
class UserHeaderPage extends React.PureComponent {
//let { slug } = useParams()
    constructor(props) {
        super(props)
        let me = this
        this.title = 'TacosContainerPageTitle'
        
      
    }
    componentWillMount()	{
        let { slug } = useParams()
        console.log('sv--task=--- link sends us params good')
        console.log(this.props.params)
        let id;
        if(this.props.params){
           id = this.props.params.id
        
        }else{
         console.log('not called by router we might be creat')
         id = -11;
        }
       
   console.log('sbv--sjourn id ****+++++++++++++++++++++++++++ we will use _doc as the space has details of sohourn as single flat indxex:'+ id)
   
   
    }
    render() {
    return (
      <div>

        <p>
          SV UserHeaderPage Component
        </p>
      
       
     <h1>
        Blue UserHeaderPage Header
        <Badge bg="secondary" as={Button}>
          New UserHeaderPage Bage
        </Badge>
      </h1>
        
      </div>
    )
  }
}
*/

